<template>
  <div>
    <!-- <div class="page-box">
      {{ pageNum }} / {{ pageTotalNum }}
    </div> -->
    <!-- <pdf
    class="pdf-box"
      :page="pageNum"
      :src="url"
      @progress="loadedRatio = $event"
      @num-pages="pageTotalNum = $event"
    ></pdf> -->
    <pdf
      ref="pdf"
      v-for="i in numPages" 
      :key="i"  
      :src="url" 
      :page="i"
      ></pdf>
    <!-- <el-button-group class="pageBtn-box">
      <el-button
        type="primary"
        icon="el-icon-arrow-left"
        @click="prePage"
        >上一页</el-button
      >
      <el-button type="primary" @click="nextPage"
      style="margin-left:20px"
        >下一页<i class="el-icon-arrow-right el-icon--right"></i
      ></el-button>
    </el-button-group> -->
  </div>
</template>
<script>
import pdf from "vue-pdf";
export default {
  name: "OperationGuide",
  components: {
    pdf
  },
  data() {
    return {
      url:
        "https://school.zzsasoft.com/uploads/files/20200511/%E5%B9%B3%E5%8F%B0%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97.pdf",
      pageNum: 1,
      pageTotalNum: 1, // 总页数
      loadedRatio: 0, // 当前页面的加载进度，范围是0-1 ，等于1的时候代表当前页已经完全加载完成了
      numPages:null
      
    };
  },
   mounted() {
      this.getNumPages()
  },
  methods: {
    //   计算pdf页码总数
      getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.url)
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages
      }).catch(err => {
        console.error('pdf 加载失败', err);
      })
    },
    // 上一页
    prePage() {
      let page = this.pageNum;
      page = page > 1 ? page - 1 : this.pageTotalNum;
      this.pageNum = page;
    },

    // 下一页
    nextPage() {
      let page = this.pageNum;
      page = page < this.pageTotalNum ? page + 1 : 1;
      this.pageNum = page;
    }
  }
};
</script>
<style scoped lang="scss">
.page-box{
    height: 60px;
    font-size: 24px;
    color: #409EFF;
    display: flex;
    justify-content: center;
    align-items: center;
}
.pdf-box{
    height: 90%;
    overflow-y: scroll;
}
.pageBtn-box{
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
